import { AfterViewInit, Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'fun-calendar-pay-overview',
  templateUrl: './calendar-pay-overview.component.html',
  styleUrls: ['./calendar-pay-overview.component.scss'],
})
export class CalendarPayOverviewComponent implements OnInit, AfterViewInit {

  @Input() calendarBenefits: any;
  @Input() isInvestor: boolean;

  benefitsByMonth = [];
  fullBenefits = [];

  text = this.translate.instant('PAYMENT_CALENDAR.NO_PAY');
  image = 12;

  mode: string;

  constructor(private utils: UtilsService, private translate: TranslateService) { }

  ngOnInit() {
    this.mode = 'list';
    for (let i = 0; i < this.calendarBenefits.length; i++) {
      for (let j = 0; j < this.calendarBenefits[i].benefits.length; j++) {
        this.calendarBenefits[i].benefits[j]['month'] = this.utils.parseMonthShort(this.calendarBenefits[i].date[1]);
        this.calendarBenefits[i].benefits[j]['day'] = this.calendarBenefits[i].date[2];
        this.calendarBenefits[i].benefits[j]['showBreakdown'] = false;
      }
    }
    if (this.isInvestor === false) {
      this.text = this.translate.instant('PAYMENT_CALENDAR.NO_PAY_NO_INVESTOR');
    }
  }

  ngAfterViewInit() {
    for (let i = 0; i < this.calendarBenefits.length; i++) {
      for (let j = 0; j < this.calendarBenefits[i].benefits.length; j++) {
        const el = document.getElementById(`overview-breakdown-${i}-${j}`);
        if (el) {
          el.style.height = '0px';
          el.style.transition = 'height 0.5s';
        }
      }
    }
  }

  toggleBreakdown(movement: any, outerIdx: number, innerIdx: number) {
    movement.showBreakdown = !movement.showBreakdown;
    const el = document.getElementById(`overview-breakdown-${outerIdx}-${innerIdx}`);
    if (el) {
      el.style.height = movement.showBreakdown ? `${el.scrollHeight}px` : '0px';
    }
  }

  changeMode(mode) {
    this.mode = mode;
  }

}
